export default "__VITE_ASSET__xFqCycMl__"